import { styled, useTheme } from "@mui/material";
import { ReactNode } from "react";

// Constants to replace magic numbers
const FIELD_LABEL_MIN_WIDTH = "120px";
const FIELD_LABEL_FONT_SIZE = "12px";
const FIELD_LABEL_OPACITY = 0.6;
const FIELD_LABEL_FONT_WEIGHT = 500;
const FIELD_VALUE_FONT_SIZE = "16px";

export const FieldLabel = styled("span")(({ theme }) => ({
  fontWeight: FIELD_LABEL_FONT_WEIGHT,
  fontSize: FIELD_LABEL_FONT_SIZE,
  opacity: FIELD_LABEL_OPACITY,
  minWidth: FIELD_LABEL_MIN_WIDTH,
  display: "inline-block",
}));

export const FieldContainer = styled("div")(({ theme }) => ({
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  fontSize: FIELD_VALUE_FONT_SIZE,
}));

interface FieldDisplayProps {
  label: ReactNode;
  value: ReactNode;
  alignItems?: "center" | "flex-start";
  noWrap?: boolean;
}

export const FieldDisplay = ({
  label,
  value,
  alignItems = "center",
  noWrap = false,
}: FieldDisplayProps) => (
  <FieldContainer sx={{ alignItems }}>
    <FieldLabel>{label}</FieldLabel>
    <span style={{ whiteSpace: noWrap ? "nowrap" : "normal" }}>{value}</span>
  </FieldContainer>
);
